<form (ngSubmit)="submit()">
  <div class="form-content">
    <div class="form-block">
      <app-form-field-text
        [field]="translationKeyControl"
        [errorMessages]="translationKeyErrorMessages"
        [prefix]="translationKeyPrefix"
        [required]="true"
        label="label.university.translation-key"
      ></app-form-field-text>
      <app-form-field-text
        [field]="nameDeControl"
        [required]="true"
        label="label.university.name-de"
      ></app-form-field-text>
      <app-form-field-text
        [field]="nameEnControl"
        [required]="true"
        label="label.university.name-en"
      ></app-form-field-text>
      <app-form-field-select
        [field]="countryControl"
        [options]="countryOptions"
        [required]="true"
        sortBy="translated-label-asc"
        label="label.country"
      ></app-form-field-select>
      <app-form-field-text
        [field]="descriptionControl"
        label="label.hint"
      ></app-form-field-text>
      <app-form-field-select
        [field]="applicationsControl"
        [options]="templateOptions"
        [multiple]="true"
        sortBy="translated-label-asc"
        label="label.university.test-templates-applications"
      ></app-form-field-select>
      <app-form-field-select
        [field]="autoSendControl"
        [errorMessages]="autoSendErrorMessages"
        [options]="templateOptions"
        [multiple]="true"
        sortBy="translated-label-asc"
        label="label.university.test-templates-auto-send"
      ></app-form-field-select>
    </div>
  </div>

  <div class="d-flex justify-content-between mb-3">
    <button
      [routerLink]="['/home/university']"
      class="btn btn-outline-primary"
      type="button"
    >
      {{ 'button.cancel' | translate }}
    </button>
    <button class="btn btn-primary" type="submit">
      {{ 'button.save' | translate }}
    </button>
  </div>
</form>
